import { Sort, SortDirection } from 'types';

// Helpers for the `?ordering=` query param used by DRF OrderingFilter-backed endpoints:
// `code` sorts ascending, `-code` descending.

export function toOrdering<Column extends string>({ column, direction }: Sort<Column>): string {
    return direction === 'desc' ? `-${column}` : column;
}

export function parseOrdering<Column extends string>(
    value: string | null | undefined,
    columns: readonly Column[]
): Sort<Column> | null {
    if (!value) return null;
    const direction: SortDirection = value.startsWith('-') ? 'desc' : 'asc';
    const column = (direction === 'desc' ? value.slice(1) : value) as Column;
    return columns.includes(column) ? { column, direction } : null;
}

// The sort that clicking `column` should produce: a second click on the active column flips the
// direction, a click on any other column sorts it ascending.
export function nextSort<Column extends string>(current: Sort<Column> | null, column: Column): Sort<Column> {
    if (current?.column === column) {
        return { column, direction: current.direction === 'asc' ? 'desc' : 'asc' };
    }
    return { column, direction: 'asc' };
}
